<template>
  <AppForm :label="label">
    <v-btn @click="addRange" small icon outline>
      <v-icon>add</v-icon>
    </v-btn>
    <v-layout v-if="settings.length === 0">
      <span style="color:red;">配信停止</span>
    </v-layout>
    <v-layout
      v-for="(setting, index) in settings"
      :key="index"
      row
      class="mb-2"
    >
      <v-select
        :items="hourListStart"
        :value="setting.startHour"
        @change="changeStartValue($event, index)"
        hide-details
        class="hour-select"
      />
      <span class="mx-4 mt-2">〜</span>
      <v-select
        :items="hourListEnd"
        :value="setting.endHour"
        @change="changeEndValue($event, index)"
        hide-details
        class="hour-select"
      />
      <v-btn @click="deleteRange(index)" icon small color="error">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
  </AppForm>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '月曜日',
    },
    day: {
      type: String,
      default: 'monday',
    },
    value: {
      type: Array,
      default: () => [],
    },
    hourListStart: {
      type: Array,
      default: () => [],
    },
    hourListEnd: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    settings: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    nextStartHour() {
      if (this.settings.length === 0) return 0
      return Math.min(
        this.settings.reduce((max, hour) => {
          if (max < hour.endHour) return hour.endHour + 1
          else return max
        }, 0),
        23,
      )
    },
  },
  methods: {
    addRange() {
      this.settings.push({
        startHour: this.nextStartHour,
        endHour: 23,
        day: this.day,
      })
    },
    deleteRange(index) {
      this.settings.splice(index, 1)
    },
    changeStartValue(value, index) {
      this.settings[index].startHour = value
      this.$emit('input', this.settings)
    },
    changeEndValue(value, index) {
      this.settings[index].endHour = value
      this.$emit('input', this.settings)
    },
  },
}
</script>

<style scoped>
.hour-select {
  max-width: 200px;
}
</style>
